import { render, staticRenderFns } from "./ProductInformationSection.vue?vue&type=template&id=04c16f68"
import script from "./ProductInformationSection.vue?vue&type=script&lang=js"
export * from "./ProductInformationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports